import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=6fb6dabb&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb6dabb')) {
      api.createRecord('6fb6dabb', component.options)
    } else {
      api.reload('6fb6dabb', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=6fb6dabb&", function () {
      api.rerender('6fb6dabb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ss7mg8owysBL/JS/comp/FavElement.vue"
export default component.exports